import { useRouteError } from 'react-router-dom'
import { isAxiosError } from 'axios'
import { Button } from '@/components/ui/button'

function NetworkError() {
  const handleReload = () => {
    window.location.reload()
  }
  return (
    <div className="flex h-svh w-full max-w-md flex-col items-center justify-center space-y-6 bg-background text-center">
      <h1 className="text-2xl font-bold">Connection error</h1>
      <p className="text-muted-foreground">
        We are unable to connect to the server. Please check your internet connection and try
        again.
      </p>
      <Button type="button" onClick={handleReload}>
        Reload
      </Button>
    </div>
  )
}

export default function ErrorPage() {
  const error = useRouteError()

  if (import.meta.env.DEV) {
    console.error(error)
  }

  if (isAxiosError(error) && error.code === 'ERR_NETWORK') {
    return <NetworkError />
  }

  return (
    <div className="flex h-svh w-full max-w-md flex-col items-center justify-center space-y-6 bg-background text-center">
      <h1 className="text-2xl font-bold">Something went wrong</h1>
      <p className="text-muted-foreground">
        Sorry, an unexpected error has occurred. You can try going back or reloading the page.
      </p>
    </div>
  )
}
